var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "insicht insicht--fade-up" },
    [
      _c(
        "div",
        { staticClass: "vouchers__container" },
        [
          _vm.initialError
            ? _c("GeneralMessage", {
                ref: "initialError",
                attrs: { message: _vm.initialError, type: "error" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.content.text
            ? _c("div", {
                staticClass: "vouchers__content",
                domProps: { innerHTML: _vm._s(_vm.content.text) }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.content.videoUrl
            ? _c("Button", {
                attrs: {
                  type: "button",
                  level: "tertiary",
                  text: _vm.$t("vouchers.tutorialButton"),
                  arrow: ""
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.onVideoClick(_vm.content.videoUrl)
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "vouchers__form" },
        [
          _vm.response.message
            ? _c("GeneralMessage", {
                ref: "message",
                attrs: {
                  message: _vm.response.message,
                  type: _vm.response.type,
                  stick: ""
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("ValidationObserver", {
            ref: "form",
            staticClass: "checkout-form__form-wrapper vouchers__form-wrapper",
            attrs: { tag: "form", novalidate: "" },
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.onSubmit.apply(null, arguments)
              }
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var invalid = ref.invalid
                  var errors = ref.errors
                  return [
                    _c(
                      "div",
                      { staticClass: "input-row" },
                      [
                        _c("ValidationProvider", {
                          staticClass: "input-row__wrapper",
                          attrs: {
                            name: "reloadValue",
                            rules: "required",
                            tag: "div",
                            customMessages: {
                              required: _vm.$t("forms.errors.fieldEmpty")
                            }
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  var invalid = ref.invalid
                                  var validated = ref.validated
                                  return [
                                    _c("FormInput", {
                                      attrs: {
                                        type: "number",
                                        placeholder: _vm.$t(
                                          "vouchers.amountLabel"
                                        ),
                                        label: _vm.$t("vouchers.amountLabel"),
                                        error: errors.length > 0,
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.form.amount,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "amount", $$v)
                                        },
                                        expression: "form.amount"
                                      }
                                    }),
                                    _vm._v(" "),
                                    invalid && validated
                                      ? _c("span", {
                                          staticClass: "input-error",
                                          domProps: {
                                            innerHTML: _vm._s(errors[0])
                                          }
                                        })
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "input-row" },
                      [
                        _c("ValidationProvider", {
                          staticClass: "input-row__wrapper",
                          attrs: {
                            name: "reloadCardNumber",
                            rules: "required",
                            tag: "div",
                            customMessages: {
                              required: _vm.$t("forms.errors.fieldEmpty")
                            }
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  var invalid = ref.invalid
                                  var validated = ref.validated
                                  return [
                                    _c("FormInput", {
                                      attrs: {
                                        type: "text",
                                        placeholder: _vm.$t(
                                          "vouchers.cardNumberLabel"
                                        ),
                                        label: _vm.$t(
                                          "vouchers.cardNumberLabel"
                                        ),
                                        error: errors.length > 0,
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.form.cardNumber,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "cardNumber", $$v)
                                        },
                                        expression: "form.cardNumber"
                                      }
                                    }),
                                    _vm._v(" "),
                                    invalid && validated
                                      ? _c("span", {
                                          staticClass: "input-error",
                                          domProps: {
                                            innerHTML: _vm._s(errors[0])
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("span", {
                                      staticClass: "additional-info",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t("vouchers.cardNumberHint")
                                        )
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("Button", {
                      attrs: {
                        type: "submit",
                        level: "primary",
                        text: _vm.$t("vouchers.reloadButton"),
                        disabled: _vm.formLocked
                      }
                    })
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("Modal", { ref: "videoModal" }, [
        _c("div", {
          staticClass: "overlay-video",
          domProps: { innerHTML: _vm._s(_vm.videoEmbedCode) }
        })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }